import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import { uniqueId } from "lodash";
import { Fragment } from "react";
import { SummaryTableStyles } from "../Styles/TableWithExpandedRowsStyles";
const isOdd = number => number % 2 === 1;
type TableContentRowType = {
  data: (string | number | React.ReactNode)[];
  subRows?: (string | number)[][];
};

export default function TableWithExpandedRows({
  tableHeaders,
  tableContent,
  numericColumns,
}: {
  tableHeaders?: string[];
  tableContent: TableContentRowType[];
  numericColumns?: number[];
}) {
  return (
    <SummaryTableStyles>
      <Table>
        {tableHeaders && (
          <TableHead>
            <TableRow>
              {tableHeaders.map((title, index) => {
                return (
                  <TableCell
                    key={title}
                    className={`${
                      numericColumns?.includes(index + 1) ? "numeric" : ""
                    }`}
                  >
                    {title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {tableContent.map(({ data, subRows }, i) => {
            return (
              <Fragment key={uniqueId("row")}>
                <TableRow>
                  {data.map((value, index) => {
                    return (
                      <TableCell
                        key={uniqueId("cell")}
                        className={`${
                          numericColumns?.includes(index + 1) ? "numeric" : ""
                        }`}
                      >
                        {value}
                      </TableCell>
                    );
                  })}
                </TableRow>

                {subRows ? (
                  <TableSubRows
                    subRows={subRows}
                    numericColumns={numericColumns}
                  />
                ) : (
                  ""
                )}
              </Fragment>
            );
          })}
        </TableBody>
      </Table>
    </SummaryTableStyles>
  );
}

const TableSubRows = ({
  subRows,
  numericColumns,
}: {
  subRows: (string | number)[][];
  numericColumns?: number[];
}) => {
  return (
    <>
      {subRows.map((subRow, index) => {
        return (
          <TableRow
            key={uniqueId("subRow")}
            className={`subRow ${isOdd(index + 1) ? "oddRow" : ""}`}
          >
            {subRow.map((value, index) => {
              return (
                <TableCell
                  key={uniqueId("cell")}
                  className={`subRowCell ${
                    numericColumns?.includes(index + 1) ? "numeric" : ""
                  }`}
                >
                  {value}
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </>
  );
};
